import { render, staticRenderFns } from "./LocationMessage.vue?vue&type=template&id=27df69d2&scoped=true"
import script from "./LocationMessage.vue?vue&type=script&lang=js"
export * from "./LocationMessage.vue?vue&type=script&lang=js"
import style0 from "./LocationMessage.vue?vue&type=style&index=0&id=27df69d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27df69d2",
  null
  
)

export default component.exports